<template>
  <div class="sm-vs-select" :class="{ 'placeholder-option': value === undefined || value === null }">
    <vs-select v-bind="[$attrs, $props]" v-on="$listeners" :value="value" class="w-full" @input="$emit('input', value)">
      <slot></slot>
    </vs-select>
    <img :src="require('@/assets/images/icons/icon-x-circle.svg')" alt="" v-if="clearable && value" class="clear-icon" @click="onClear" />
  </div>
</template>

<script>
export default {
  name: 'sm-vs-select',
  inheritAttrs: false,
  props: {
    value: {
      type: String | Number,
      required: true
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClear () {
      this.$emit('input', undefined);
      this.$emit('clear');
    }
  }
};
</script>

<style lang="scss">
.sm-vs-select {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;

  .clear-icon {
    position: absolute;
    width: 18px;
    height: 18px;
    right: -30px;
    font-weight: 100;
    cursor: pointer;
  }

  &.placeholder-option {
    .input-select.vs-select--input {
      color: #c4c4c4;
    }
  }
}
</style>